import React from 'react';
import { Table2, FileText, Presentation, File } from 'lucide-react';
import { getFileExtension } from '../../utils/file-validation';

export interface FileIconProps {
  filename: string;
  className?: string;
}

export const FileIcon: React.FC<FileIconProps> = ({ filename, className = '' }) => {
  const ext = getFileExtension(filename);

  let Icon = File;
  let colorClass = 'text-secondary bg-surface-container-high';

  if (['.xlsx', '.xls', '.csv'].includes(ext)) {
    Icon = Table2;
    colorClass = 'text-green-600 bg-green-50';
  } else if (ext === '.pdf') {
    Icon = FileText;
    colorClass = 'text-red-600 bg-red-50';
  } else if (['.docx', '.doc', '.txt'].includes(ext)) {
    Icon = FileText;
    colorClass = 'text-blue-600 bg-blue-50';
  } else if (['.ppt', '.pptx'].includes(ext)) {
    Icon = Presentation;
    colorClass = 'text-orange-600 bg-orange-50';
  }

  return (
    <div className={`p-2 rounded-lg ${colorClass} ${className}`}>
      <Icon className="w-5 h-5" />
    </div>
  );
};
